export default __webpack_public_path__ + "static/media/labyrinthen-tenancy-02.064dab89.jpg";